/**
 * Shared auth cookie on .payara.id so sibling apps (e.g. app-moneyin) can auto-login.
 */

const COOKIE_NAME = 'auth_token';
const COOKIE_DOMAIN = '.payara.id';
const COOKIE_MAX_AGE = 86400;

// Browsers reject cookies whose Domain doesn't match the current host.
const isPayaraHost = () => window.location.hostname.endsWith('payara.id');

export function setAuthCookie(token) {
  if (!token || !isPayaraHost()) return;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(token)}; Domain=${COOKIE_DOMAIN}; Path=/; Secure; SameSite=Lax; Max-Age=${COOKIE_MAX_AGE}`;
}

export function clearAuthCookie() {
  if (!isPayaraHost()) return;
  document.cookie = `${COOKIE_NAME}=; Domain=${COOKIE_DOMAIN}; Path=/; Secure; SameSite=Lax; Max-Age=0`;
}

export const MONEYIN_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://app-moneyin.payara.id/'
    : 'https://dev-app-moneyin.payara.id/';
